import config from '../config';

export default url => config.trustedSources.some(trustedSite => url.indexOf(trustedSite) === 0);
